import { serviceHelper } from '../utils/serviceHelper'

export const findById = async (id) => {
  const userApi = getAxiosCreate()
  const { data } = await userApi.get(`/users/id/${id}`)
  return data
}

const getAxiosCreate = () => {
  return serviceHelper.createApiClient(`${process.env.REACT_APP_USER_URL}`)
}
